export default __webpack_public_path__ + "static/media/24-month-plan-illustration.04cae58b.svg";